import React from 'react';
import { PropTypes } from 'prop-types';
import { Typography } from '@mui/material';

const DashboardTitle = props => {
    const { children, sx, ...rest } = props;

    return (
        <Typography
            sx={theme => ({
                ml: 3,
                [theme.breakpoints.down('md')]: {
                    fontSize: '30px',
                },
                width: '100%',
                ...(typeof sx === 'function' ? sx(theme) : sx),
            })}
            variant="h5"
            align="left"
            {...rest}
        >
            {children}
        </Typography>
    );
};

DashboardTitle.propTypes = {
    children: PropTypes.node,
    sx: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};

export default DashboardTitle;
